import React, { Fragment } from 'react';

import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";
import SpinnerDiv from "ui/ReactSpinnerDiv";

const DropdownConcernReportType = ( { control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, mode } ) =>
{
    const url = '/concernReportType';

    const fields = { url: url, keyFieldName: 'id', labelFieldName: 'type', additionalFields: [] }

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownConcernReportType;
